function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { pause } from './index';
export var waitForDefined = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
    var delay,
        value,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            delay = _args.length > 1 && _args[1] !== undefined ? _args[1] : 10;
            _context.next = 3;
            return typeof res === 'function' ? res() : res;

          case 3:
            value = _context.sent;

            if (!(value === undefined)) {
              _context.next = 8;
              break;
            }

            _context.next = 7;
            return pause(delay !== null && delay !== void 0 ? delay : 10, 'ms');

          case 7:
            return _context.abrupt("return", waitForDefined(res));

          case 8:
            return _context.abrupt("return", value);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function waitForDefined(_x) {
    return _ref.apply(this, arguments);
  };
}();